import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'owl.carousel/dist/owl.carousel.js';
import { ServiceCatalogueService } from 'src/modules/module-service-catalogue/_services/module-service-catalogue-service.service';
import { LoaderService } from 'src/modules/shared/services/loader.service';
import { DataSharingService } from '../shared/services/DataSharing.service';
import { AppConfigService } from '../shared/services/app-config.service';
import { LoginService } from '../login/services/login.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  cards = []
  loggedIn: any;

  constructor(
    private loginService: LoginService,
    private service: ServiceCatalogueService,
    private dataSharingService:DataSharingService,
    private appConfig: AppConfigService) {
  this.dataSharingService.isUserLoggedIn.subscribe(value => {
      this.loggedIn = value;
    });
   }
  ngOnInit() {
    // let params = {
    //   "HeaderProperties": {
    //     "UserLanguage": localStorage.getItem('lang') == 'ar' ? localStorage.getItem('lang') + '-SA' : 'en'
    //   }
    // }

    // LoaderService.showLoader();

    // this.service.onGetModules('GetMTTmodules', params).subscribe(response => {
    //   // response['Result'].map((item) => item.iconClass = 'icon-truck');
    //   this.cards = response['Result'];

    //   LoaderService.hideLoader();

    // })
//  this.loggedIn= sessionStorage.getItem("loggedIn");
 
  }

  Login(){
    this.loginService.RedirectToLogin();
  }

  /*--------------------owl carosel options----------*/
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    margin: 30,
    navSpeed: 700,
    navText: ['<span class="icon-arrow"> </span>', '<span class="icon-arrow-left"> </span>'],
    responsive: {
      0: {
        items: 1,
        nav: false,
        dots: true
      },
      400: {
        items: 2,
        nav: false,
        dots: true
      },
      740: {
        items: 3,
        nav: false,
        dots: true
      },
      940: {
        items: 3,
        nav: true,
        dots: false
      }
    }

  }

}
